import { UserService } from "@/services/UserService";

export class UserUtils{

  static async fetchApiKey(gameId: string):Promise<string>{
    const userService = new UserService();
    const apiKey:string = await userService.getGameApiKey(gameId);
    return apiKey;
  }
}